import React, { Fragment } from 'react'
import Img1 from "../images/delay.png"
import Img2 from "../images/review.png"


const TopBarValues = ({
    resolved_count,
    pending_count,
    rejected_count,
    under_review_count,
}) => {




    return (
        <Fragment>
            <div className="flex justify-center gap-[1vmax] lg:gap-[2vmax] mb-[1vmax] flex-wrap">
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >{pending_count || 0}</span>
                        <span className="text-gray-600  uppercase text-[1vmax]" >Pending</span>
                    </div>
                    <div className="w-[35%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-orange-500 rounded-full grid 
                        place-items-center">
                            <img src={Img1} alt="" className='w-[1.8vmax] filter invert brightness-0' />

                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg justify-between">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >&nbsp;
                            {under_review_count || 0}
                        </span>
                        <span className="text-gray-600  uppercase text-[1vmax]" >Under Review </span>
                    </div>
                    <div className="w-[20%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-blue-500 rounded-full grid place-items-center">
                            <img src={Img2} alt="" className='w-[1.8vmax] filter invert brightness-0' />
                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >
                            {resolved_count || 0}</span>
                        <span className="text-gray-600 uppercase text-[1vmax]" >  Resolved </span>
                    </div>
                    <div className="w-[35%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-green-400 rounded-full grid place-items-center">
                            <i className="fa-solid fa-check text-white text-[1.5vmax]"></i>
                        </div>
                    </div>
                </div>
                <div className="w-[48%] lg:w-[18%] flex bg-white p-[1vmax] shadow-1 rounded-lg">
                    <div className="w-[65%] flex justify-between flex-col gap-[1vmax]">
                        <span className="text-[2vmax] font-3 font-[700] text-gray-600" >
                            {rejected_count || 0}</span>
                        <span className="text-gray-600 uppercase text-[1vmax]" >Rejected </span>
                    </div>
                    <div className="w-[35%] flex justify-end items-center">
                        <div className="w-[2.5vmax] h-[2.5vmax] bg-red-500 rounded-full grid place-items-center">
                            <i className="fa-solid fa-xmark text-white text-[1.5vmax]"></i>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default TopBarValues